var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sa-aggiungiarticolo sa-aggiungiarticolo-hidden",attrs:{"id":"boxCreazioneArticolo"}},[_c('magazzino-articoli-anagrafica-edit-component',{ref:"cmpMagazzinoArticoliAnagraficaEditComponent"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }